module.exports = __webpack_public_path__ + "img/background.72e4db1d.jpg";